import { Button, Divider, Form, Input, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { bankOptions, filterBankOption } from '../../../../../utils/bankList';
import './BankAccount.scss';

const { Option } = Select;

const bankAccountTypes = {
  CHECKING_ACCOUNT: 'Conta Corrente',
  SAVINGS_ACCOUNT: 'Conta Poupança',
  PAYMENT_ACCOUNT: 'Conta de Pagamento'
};

const normalizeBankCode = (code) => {
  if (!code) return code;
  return String(code).replace(/^0+/, '') || code;
};

const BankAccount = ({ data, onSave, onDiscard, setUnsavedChanges, setDataToSave }) => {
  const [enableEdit, setEnableEdit] = useState(false);
  const [localData, setLocalData] = useState(data);
  const [errors, setErrors] = useState({});
  
  useEffect(() => {
    setLocalData(data);
  }, [data]);

  useEffect(() => {
    if (localData) {
      setDataToSave(localData);
      validateFields(localData);
    }
  }, [localData, setDataToSave]);

  const validateFields = (data) => {
    const newErrors = {};
    const bankAccount = data?.bank_account || {};
    
    if (!bankAccount.number) newErrors.number = 'Campo obrigatório';
    if (!bankAccount.agency) newErrors.agency = 'Campo obrigatório';
    if (!bankAccount.code) newErrors.code = 'Campo obrigatório';
    if (!bankAccount.type) newErrors.type = 'Campo obrigatório';
    
    setErrors(newErrors);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLocalData(prevData => {
      const newData = {
        ...prevData,
        bank_account: {
          ...prevData.bank_account,
          [name]: value
        }
      };
      setUnsavedChanges(true);
      validateFields(newData);
      return newData;
    });
  };

  const handleSelectChange = (value, name) => {
    setLocalData(prevData => {
      const newData = {
        ...prevData,
        bank_account: {
          ...prevData.bank_account,
          [name]: value
        }
      };
      setUnsavedChanges(true);
      validateFields(newData);
      return newData;
    });
  };

  const handleSave = async () => {
    if (Object.keys(errors).length === 0) {
      await onSave(localData);
      setEnableEdit(false);
      setUnsavedChanges(false);
    } else {
      alert('Por favor, corrija os campos obrigatórios.');
    }
  };

  const handleDiscard = async () => {
    await onDiscard();
    setEnableEdit(false);
    setUnsavedChanges(false);
    setLocalData(data);
  };

  const bankAccount = localData?.bank_account || {};
  
  // Find the bank label for the given code
  const getBankLabel = (code) => {
    if (!code) return "Não informado";
    const normalized = normalizeBankCode(code);
    const bank = bankOptions.find(b => b.value === normalized);
    return bank ? bank.label : code;
  };

  return (
    <div className='BankAccount'>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <p className='subtitle-page'>Conta Bancária</p>
        <Button
          onClick={() => setEnableEdit(!enableEdit)}
          type={enableEdit ? "primary" : ""}
        >
          {enableEdit ? "Cancelar" : "Editar"}
        </Button>
      </div>
      <Divider />
      <div className="container-inputs">
        <div className="left-inputs">
          <Form layout="vertical">
            <Form.Item
              label="Código do Banco"
              help={errors.code}
              validateStatus={errors.code ? 'error' : ''}
            >
              {enableEdit ? (
                <Select
                  value={normalizeBankCode(bankAccount.code) || undefined}
                  onChange={(value) => handleSelectChange(value, 'code')}
                  placeholder="Selecione um banco"
                  showSearch
                  optionFilterProp="label"
                  filterOption={filterBankOption}
                  options={bankOptions}
                />
              ) : (
                <Input disabled value={getBankLabel(bankAccount.code)} readOnly />
              )}
            </Form.Item>
            <Form.Item
              label="Número da Conta"
              help={errors.number}
              validateStatus={errors.number ? 'error' : ''}
            >
              <Input
                name="number"
                disabled={!enableEdit}
                value={bankAccount.number || ""}
                onChange={handleInputChange}
                placeholder="Não informado"
              />
            </Form.Item>
          </Form>
        </div>

        <div className="right-inputs">
          <Form layout="vertical">
            <Form.Item
              label="Agência"
              help={errors.agency}
              validateStatus={errors.agency ? 'error' : ''}
            >
              <Input
                name="agency"
                disabled={!enableEdit}
                value={bankAccount.agency || ""}
                onChange={handleInputChange}
                placeholder="Não informado"
              />
            </Form.Item>
            <Form.Item
              label="Tipo de Conta"
              help={errors.type}
              validateStatus={errors.type ? 'error' : ''}
            >
              <Select
                disabled={!enableEdit}
                value={bankAccount.type || undefined}
                onChange={(value) => handleSelectChange(value, 'type')}
                placeholder="Selecione o tipo de conta"
              >
                {Object.entries(bankAccountTypes).map(([key, value]) => (
                  <Option key={key} value={key}>{value}</Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
        </div>
      </div>
      {enableEdit && (
        <div className="button-container">
          <Button onClick={handleDiscard} style={{ marginRight: 8 }}>Cancelar</Button>
          <Button onClick={handleSave} type="primary">Salvar</Button>
        </div>
      )}
    </div>
  )
}

export default BankAccount